import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import HeaderColumn from '../header-column/HeaderColumn';

import scss from './SettingsHeader.module.scss';

const SettingsHeader = () => {
  const { t } = useTranslation('header');

  return (
    <HeaderColumn>
      <h1 className={scss.title}>{t('settings')}</h1>
    </HeaderColumn>
  );
};

export default memo(SettingsHeader);
